import React, { useState, useEffect, useCallback, useContext } from 'react';
import Evento from './Evento';
import Etiquetas from './Etiquetas';
import Codes from './Codigos';
import EventoProveedores from './EventoProveedores';
import EscaneosEvento from './EscaneosEvento';
import EstadisticasEvento from './EstadisticasEvento';
import { AuthContext } from '../contexts/AuthContext';

interface Event 
{
  id: number;
  name: string;
  autonext: boolean;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
}

interface EventosProps 
{
  clientId: number;
  title: string;
  onBack: () => void;
}

const Eventos: React.FC<EventosProps> = ({ clientId, title, onBack }) => 
{
  const { token } = useContext(AuthContext);
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [viewingTags, setViewingTags] = useState<number | null>(null); // Estado para gestionar la vista de tags
  const [viewingProviders, setViewingProviders] = useState<number | null>(null); // Estado para gestionar la vista de proveedores
  const [viewingCodes, setViewingCodes] = useState<number | null>(null); // Estado para gestionar la vista de codigos
  const [viewingScans, setViewingScans] = useState<number | null>(null); // Estado para gestionar la vista de escaneos
  const [viewingEstadisticas, setViewingEstadisticas] = useState<number | null>(null); // Estado para gestionar la vista de estadisticas

  //-----------------------------------------------------------

  const fetchEvents = useCallback(async () => 
  {
    setLoading(true);
    try 
    {
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/get_client_events?id_client=${clientId}`, {
        method: 'GET',
        headers: {'X-AUTH-TOKEN': token || ''}});

      if (response.ok) 
      {
        const data = await response.json();
        setEvents(data);
      } 
      else 
      {
        throw new Error('Error al cargar eventos.');
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [clientId, token]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    fetchEvents();
  }, [fetchEvents]);

  //-----------------------------------------------------------

  const handleCreateClick = () => 
  {
    setSelectedEvent({
        id: -1, // Para indicar que es un nuevo evento
        name: '',
        autonext: false,
        start_date: '',
        end_date: '',
        start_time: '',
        end_time: ''}); // Crear un evento vacío para la creación
  };

  //-----------------------------------------------------------

  const handleEditClick = (event: Event) => 
  {
    setSelectedEvent(event); // Para editar el evento existente
  };

  //-----------------------------------------------------------

  const handleFormClose = () => 
  {
    setSelectedEvent(null); // Cerrar el formulario
    fetchEvents(); // Refrescar la lista de eventos después de guardar o eliminar
  };

  //-----------------------------------------------------------

  const handleTagsClick = (eventId: number) => 
  {
    setViewingTags(eventId); // Establecer el id del evento para ver los tags
  };

  //-----------------------------------------------------------

  const handleBackFromTags = () => 
  {
    setViewingTags(null); // Volver a la vista de eventos
  };

  //-----------------------------------------------------------

  const handleProvidersClick = (eventId: number) => 
  {
    setViewingProviders(eventId); // Establecer el id del evento para ver los proveedores
  };

  //-----------------------------------------------------------

  const handleBackFromProviders = () => 
  {
    setViewingProviders(null); // Volver a la vista de eventos
  };

  //-----------------------------------------------------------

  const i_Find_event_name_by_id = (id: number) => 
  {
        const event = events.find(event => event.id === id);
        return event ? event.name : '';
  };

  //-----------------------------------------------------------

  if (viewingProviders !== null) 
  {
    const event_name = i_Find_event_name_by_id(viewingProviders);

    return <EventoProveedores eventId={viewingProviders} title={title + " / " + event_name} onBack={handleBackFromProviders} />;
  }

  //-----------------------------------------------------------

  if (viewingTags !== null) 
  {
    const event_name = i_Find_event_name_by_id(viewingTags);

    return <Etiquetas eventId={viewingTags} title={title + " / " + event_name} onBack={handleBackFromTags} />;
  }

  //-----------------------------------------------------------

  const handleCodesClick = (eventId: number) => 
  {
    setViewingCodes(eventId); // Establecer el id del evento para ver los códigos
  };

  //-----------------------------------------------------------

  const handleBackFromCodes = () => 
  {
    setViewingCodes(null); // Volver a la vista de eventos
  };

  //-----------------------------------------------------------

  if (viewingCodes !== null) 
  {
    const event_name = i_Find_event_name_by_id(viewingCodes);

    return <Codes eventId={viewingCodes} title={title + " / " + event_name} onBack={handleBackFromCodes} />;
  }

  //-----------------------------------------------------------

  const handleEscaneosClick = (eventId: number) => 
  {    
    setViewingScans(eventId);
  };

    //-----------------------------------------------------------

  const handleBackFromScans = () => 
    {
      setViewingScans(null); // Volver a la vista de eventos
    };

  //-----------------------------------------------------------

  if (viewingScans !== null) 
  {
    const event_name = i_Find_event_name_by_id(viewingScans);

    return <EscaneosEvento eventId={viewingScans} title={title + " / " + event_name} onBack={handleBackFromScans} />;
  }


  //-----------------------------------------------------------

  const handleEstadisticasClick = (eventId: number) => 
    {    
      setViewingEstadisticas(eventId);
    };
  
      //-----------------------------------------------------------
  
    const handleBackFromEstadisticas = () => 
      {
        setViewingEstadisticas(null); // Volver a la vista de eventos
      };
  
    //-----------------------------------------------------------
  
    if (viewingEstadisticas !== null) 
    {
      const event_name = i_Find_event_name_by_id(viewingEstadisticas);
  
      return <EstadisticasEvento eventId={viewingEstadisticas} title={title + " / " + event_name} onBack={handleBackFromEstadisticas} />;
    }  
  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      <div className="miguitas">Eventos de {title}</div>
      {selectedEvent === null ? (
        <div>          
          <div>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button onClick={onBack} className="create-client-button">
                      <i className="fas fa-chevron-left"></i> Volver a Recintos
                    </button>
                  </td>
                  <td>
                    <button
                      className="create-event-button"
                      onClick={handleCreateClick}
                    >
                      <i className="fas fa-plus-circle"></i> Crear EVENTO
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {loading && <p>Buscando eventos...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && events.length === 0 && <p>No hay eventos para mostrar.</p>}
          {!loading && !error && events.length > 0 && (
            <table className="eventos-table">
              <tbody>
                {events.map(event => (
                  <tr key={event.id}>
                    <td className="evento-name">{event.name}</td>
                    <td className="evento-autonext">
                      {new Date(event.start_date).toLocaleDateString()} 
                      {new Date(event.start_date).toLocaleDateString() === new Date(event.end_date).toLocaleDateString() ? '' : `  ${new Date(event.end_date).toLocaleDateString()}`}
                    </td>
                    <td className="evento-times">
                      {event.start_time} - {event.end_time}
                    </td>
                    <td className="evento-autonext">
                      {event.autonext ? 'Autonext' : 'Normal'}
                    </td>
                    <td className="evento-actions">
                      <button className="action-button edit-button" onClick={() => handleEditClick(event)}><i className="fas fa-pencil"></i>Editar</button>
                    </td>
                    <td className="evento-actions">
                      <button className="action-button tags-button" onClick={() => handleTagsClick(event.id)}><i className="fas fa-hashtag"></i>Tags</button>
                    </td>                    
                    <td className="evento-actions">
                      <button className="action-button-widest" onClick={() => handleProvidersClick(event.id)}><i className="fas fa-handshake"></i>Proveedores</button>
                    </td>                    
                    <td className="evento-actions">
                      <button className="action-button-wide" onClick={() => handleCodesClick(event.id)}><i className="fas fa-ticket"></i>Códigos</button>
                    </td>
                    <td className="evento-actions">
                      <button className="action-button-wide" onClick={() => handleEscaneosClick(event.id)}><i className="fas fa-barcode"></i>Escaneos</button>
                    </td>     
                    <td className="evento-actions">
                      <button className="action-button-wider" onClick={() => handleEstadisticasClick(event.id)}><i className="fas fa-chart-line"></i>Estadísticas</button>
                    </td>                 
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div className="form-overlay">
          <Evento
            event={selectedEvent} 
            id_client={clientId} // Pasar el id_client para la creación de nuevos eventos
            onSave={handleFormClose}
            onCancel={handleFormClose}
            onDelete={(eventId) => {
              setEvents(events.filter(event => event.id !== eventId));
              handleFormClose();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Eventos;
